// eslint-disable-next-line prefer-destructuring
export const COOKIE_TAG = process.env.COOKIE_TAG;
// eslint-disable-next-line prefer-destructuring
export const CAPTCHA_KEY = process.env.CAPTCHA_KEY;
export const CYHOME_HTML_PRINT = 'cyhome-htmlPrint';
